<template>
  <layout-envelope
    :style="{ background: isMobileScreen ? 'white' : background }"
  >
    <top-small
      ><template v-slot:left>
        <back-button
          class="text-interaction-dark"
          :back-action="() => $router.go(-1)"
        ></back-button> </template
      ><span
        class="mx-8 block text-center text-interaction-dark border-interaction-dark border-b-2 lg:border-b-2px text-chplus-regular font-bold"
        >{{ $t("views.single.list.title") }}</span
      ></top-small
    >
    <top-sub-b
      ><span class="text-chplus-regular text-color-regular">{{
        $t("views.single.list.subtitle")
      }}</span></top-sub-b
    >
    <div class="grid grid-cols-3 overflow-y-auto pb-8">
      <candidate-list
        :list-id="listId"
        :electionView="true"
        :allow-collapse="false"
        :expanded="true"
        :show-tools="false"
        class="col-start-2"
      />
    </div>
  </layout-envelope>
</template>

<script>
import store from "@/store";

import LayoutEnvelope from "@/components/layouts/LayoutEnvelope";
import CandidateList from "@/components/list/List";
import BackButton from "@/components/buttons/BackButton";
import TopSubB from "@/components/layouts/TopSubB";
import TopSmall from "@/components/layouts/TopSmall";
import { ProgressStepId } from "@/utils/ProgressStepId";
import { mapGetters } from "vuex";
import IsMobileMixin from "@/utils/IsMobileMixin";

export default {
  name: "List",
  components: {
    TopSmall,
    TopSubB,
    LayoutEnvelope,
    // Tutorial,
    CandidateList,
    BackButton
  },
  props: {
    listId: {
      type: Number,
      required: true
    }
  },
  mixins: [IsMobileMixin],
  async beforeRouteEnter(to, from, next) {
    if (!store.getters["user/hasProgress"](ProgressStepId.Favorites)) {
      next({ name: "election-home" });
      return;
    }

    if (store.getters["election/activeElection"] == null) {
      next({ name: "election-home" });
      return;
    }

    await Promise.all([
      store.dispatch("candidate/fetchCandidates"),
      store.dispatch("list/fetchLists")
    ]);
    next();
  },
  computed: {
    ...mapGetters("user", ["hasProgress", "user"]),
    ...mapGetters("location", ["canton"]),
    background() {
      return this.canton(this.user.cantonId).backgroundGradient;
    }
  }
};
</script>
